// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__wKLnV","container":"index_container__RuL_P","bigImgItem":"index_bigImgItem__MwyZ5","descList":"index_descList__4b3Wz"};